import { useContext, useMemo } from 'react';
import { UNSAFE_RouteContext as RouteContext, Routes } from 'react-router';

// <RootRoutes> is a drop-in replacement for <Routes> that ignores parent routes,
// with the effect of treating all <Route> as absolute.
// https://github.com/remix-run/react-router/discussions/9841#discussioncomment-4637486
export default function RootRoutes(props: React.ComponentProps<typeof Routes>) {
  const ctx = useContext(RouteContext);

  const value = useMemo(
    () => ({
      ...ctx,
      matches: [],
    }),
    [ctx]
  );

  return (
    <RouteContext.Provider value={value}>
      <Routes {...props} />
    </RouteContext.Provider>
  );
}
